"use client";
import React from "react";
import ReturnReasonOverviewRow from "~/app/(pages)/settings/return-reasons/ReturnReasonsOverviewRow.jsx";
import { TurnrCardContent } from "~/components/card/TurnrCard.jsx";
import LineDivider from "rylak-common/src/components/divider/LineDivider.jsx";
import { COLORS } from "rylak-common/src/constants.js";
import { PreConditionComponentProductCategories, PreConditionComponentProducts, PreConditionComponentsWrapper } from "~/app/(pages)/settings/price-setups/_pricesFeatures/PriceSetupCard.js";
import { EntityCardPriorityHeader } from "~/components/entityAction/EntityListCards.js";

function CardContent({ appProps, selectedLanguage, title, items }) {
    return items?.length > 0 ? (
        <TurnrCardContent>
            <div style={{ marginLeft: "0px", marginBottom: "15px", fontSize: "14px", color: COLORS.WEAK_TEXT }}>{title}</div>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {items?.map((item) => {
                    return <ReturnReasonOverviewRow key={item?.id} appProps={appProps} entity={item?.returnReason || item?.complaintReason} selectedLanguage={selectedLanguage} />;
                })}
            </div>
        </TurnrCardContent>
    ) : null;
}

export default function ReturnReasonConfigOverviewCardContent(props) {
    const { appProps, selectedLanguage, entity, returnConfig = entity } = props;
    return (
        <>
            <EntityCardPriorityHeader entity={returnConfig}>
                {returnConfig?.name && <div style={{ fontSize: "14px", overflowWrap: "break-word" }}>{returnConfig?.name}</div>}
                <PreConditionComponentsWrapper>
                    <PreConditionComponentProductCategories appProps={appProps} productCategoryIds={returnConfig?.productCategoryIds} />
                </PreConditionComponentsWrapper>
                <PreConditionComponentProducts appProps={appProps} productIds={returnConfig?.productIds} />
            </EntityCardPriorityHeader>
            <LineDivider />
            <CardContent appProps={appProps} selectedLanguage={selectedLanguage} title={"Return reasons"} items={returnConfig?.returnItems} />
            <LineDivider />
            <CardContent appProps={appProps} selectedLanguage={selectedLanguage} title={"Complaint reasons"} items={returnConfig?.complaintItems} />
        </>
    );
}
